import { render, staticRenderFns } from "./NovelDetailEditPage.vue?vue&type=template&id=01156056"
import script from "./NovelDetailEditPage.vue?vue&type=script&lang=ts"
export * from "./NovelDetailEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports